import React from 'react';
import { cn } from '../../lib/classNames';

const variants = {
  primary: 'bg-primary !text-white text-primary-foreground shadow-sm hover:bg-primary-hover focus-visible:ring-primary no-underline',
  secondary: 'border border-border bg-card text-foreground shadow-sm hover:bg-muted no-underline',
  outline: 'border border-input bg-transparent text-foreground hover:bg-muted no-underline',
  ghost: 'bg-transparent text-foreground hover:bg-muted no-underline',
  danger: 'bg-destructive !text-white text-destructive-foreground shadow-sm hover:opacity-90 no-underline'
};

const sizes = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-10 px-4 text-sm',
  lg: 'h-11 px-5 text-base'
};

export const Button = React.forwardRef(({
  as: Component = 'button',
  variant = 'primary',
  size = 'md',
  className,
  type,
  ...props
}, ref) => (
  <Component
    ref={ref}
    type={Component === 'button' ? (type || 'button') : undefined}
    className={cn(
      'inline-flex items-center justify-center gap-2 rounded-md font-medium no-underline transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
      variants[variant] || variants.primary,
      sizes[size] || sizes.md,
      className
    )}
    {...props}
  />
));

Button.displayName = 'Button';
